import PropTypes from 'prop-types';
import { forwardRef, useEffect, useLayoutEffect, useMemo, useRef, memo } from 'react';
import Phaser from 'phaser';
import { PhaserGame } from './PhaserGame';
import { WheelScene } from './WheelScene';

import { motion, useMotionValue, useMotionValueEvent, useTransform, useAnimationFrame} from "motion/react"

function getRandomInt(min, max) {
	const minCeiled = Math.ceil(min);
	const maxFloored = Math.floor(max);
	return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
}

const MakisBar = memo(function MakisBar(
	{
		winSlice,
		prize,
		onStopSpinning,
	}) {

	const counterRef = useRef()

	const [initialHeight, targetHeight] = useMemo(() => {
		
		let percent = 0;
		let offset = 0;
		switch(winSlice.option){
			case 'Common':
				percent = getRandomInt(40, 56)
				offset = 30
				break;
			case 'Uncommon':
				percent = getRandomInt(56, 76)
				offset = 25
				break;
			case 'Rare':
				percent = getRandomInt(76, 86)
				offset = 20
				break;
			case 'Epic':
				percent = getRandomInt(86, 98)
				offset = 10
				break;
		}

		return [
			(100 - percent + offset) + '%',
			(100 - percent) + '%',
		]

	}, [winSlice])

	const h = useMotionValue(0)
	useAnimationFrame(() => {
		if (counterRef.current) {
			let value = 100 - parseInt(h.get());
			if(value > 98) value = 98;
			if(value < 0) value = 0;

			if( isNaN(value) ) {
				counterRef.current.textContent = '%';
			}
			else{
				counterRef.current.textContent = `${value}%`;
			}
		}
	});

	const handleAnimationComplete = (latest) => {
		console.log("animation complete", latest)
		setTimeout(() => onStopSpinning(), 3000)
	}

	return (
		<div className="flex" style={{ justifyContent: 'center', alignItems: 'center',  gap: 20 }}>
			<div>
				<img src="/images/wheel/makis-posa.png" style={{ height: 500 }} />
			</div>
			<div style={{ position: 'relative', overflow: 'hidden',backgroundColor: '#f2c032', border: '5px solid black', borderRadius: '20px', height: 450, width: 90}}>
				<motion.div
					initial= {{ height: initialHeight}}
					animate={{ 
						height: targetHeight,
						// transition: {
						// 	duration: 5,
						// }
					}}
					transition={{
						type: "spring",
						stiffness: 25,
						damping: 2,
						delay: 1,
						// stiffness: 35,
						// damping: 4,
					}}
					onAnimationComplete={handleAnimationComplete}
					style={{
						backgroundColor: '#99c7bf',
						borderBottom: '2px solid black',
						// borderTopLeftRadius: '17px',
						// borderTopRightRadius: '17px',
						// outlineBottom: 'none',
						// position: 'absolute',
						// right: 0,
						// left: 0,
						// top: 0,
						overflow: 'hidden',
						height: h,
					}}
				>
					
				</motion.div>
				<div
					ref={counterRef}	
					style={{
						color: 'black',
						textAlign: 'center', 
						fontWeight: 900,
						position: 'relative',
						paddingTop: 5,
						left: 4
					}}
				>
					80<span style={{ fontSize: '14px' }}>%</span>
				</div>
			</div>
		</div>
	);

});

export default MakisBar;